import { render, staticRenderFns } from "./HuchaStep.vue?vue&type=template&id=47d62e47"
import script from "./HuchaStep.vue?vue&type=script&lang=js"
export * from "./HuchaStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports